import { core } from '../core/index.js';
/**
 * PDFviewer参数选项
 */
export type FabricUtilsOpenPdfViewerOptions = {
  /**
   * PDF网络地址
   */
  url: string;
  /**
   * PDF显示的标题
   */
  title?: string;
  /**
   * 是否禁止录屏、截图
   */
  disableScreenRecord?: boolean;
};

export type FabricUtilsOpenPdfViewerCallbackFunc = (
  data: FabricUtilsOpenPdfViewerCallbackData
) => void;

export type FabricUtilsOpenPdfViewerApi = (
  options: FabricUtilsOpenPdfViewerOptions,
  callback?: FabricUtilsOpenPdfViewerCallbackFunc
) => void;

export type FabricUtilsOpenPdfViewerCallbackData = {
  state:
    | 'onLoad'
    | 'onShow'
    | 'onHide'
    | 'onDestroy'
    | 'onScrollBottom'
    | 'onBackground';
};

/**
 * 打开PDF文件预览
 */
export const openPdfViewer: FabricUtilsOpenPdfViewerApi = (
  options: FabricUtilsOpenPdfViewerOptions,
  callback?: FabricUtilsOpenPdfViewerCallbackFunc
) => {
  core.call<
    'fabric_utils.openPdfViewer',
    FabricUtilsOpenPdfViewerOptions,
    FabricUtilsOpenPdfViewerCallbackData
  >(
    'fabric_utils.openPdfViewer',
    options,
    callback
      ? (result) => {
          callback(result.data);
        }
      : undefined
  );
};
